const TabbedContent = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.tabLinks = document.getElementsByClassName("tablinks");
    DOM.tabContent = document.getElementsByClassName("tabcontent");
  };

  const displayContent = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (DOM.tabContent) {
      Array.from(DOM.tabContent).forEach((content) => {
        content.style.display = "none";
      });
    }

    Array.from(DOM.tabLinks).forEach((links) => {
      links.classList.remove("active");
    });

    const tabName = event.currentTarget.getAttribute("data-param-tab");

    document.getElementById(tabName).style.display = "block";
    event.currentTarget.classList.add("active");
  };

  const eventListener = () => {
    if (DOM.tabLinks) {
      Array.from(DOM.tabLinks).forEach((button) => {
        button.addEventListener("click", (event) =>
          displayContent(event, true)
        );
      });
    }
  };

  const init = () => {
    cacheDOM();
    eventListener();
  };

  return {
    init,
  };
})();

export default TabbedContent;
